module.exports = __webpack_public_path__ + "assets/9685921a0a833a3736a2799c6cef7585.jpg";